import { render, staticRenderFns } from "./PiezoelectricLighterViz.vue?vue&type=template&id=066e5af2&scoped=true"
import script from "./PiezoelectricLighterViz.vue?vue&type=script&lang=js"
export * from "./PiezoelectricLighterViz.vue?vue&type=script&lang=js"
import style0 from "./PiezoelectricLighterViz.vue?vue&type=style&index=0&id=066e5af2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066e5af2",
  null
  
)

export default component.exports